import moment from 'moment'
import routeParams from 'helpers/routeParams'
import { getApiFilterBuilder, getApiPaging, getApiSort } from '../../../utils/apig02/apig02'
import { get } from 'lodash'

const GET_AWARDS_LIST = 'dofe-bo/award/GET_AWARDS_LIST'
const GET_AWARDS_LIST_SUCCESS = 'dofe-bo/award/GET_AWARDS_LIST_SUCCESS'
const GET_AWARDS_LIST_FAIL = 'dofe-bo/award/GET_AWARDS_LIST_FAIL'

const GET_AWARDS_OVERVIEW_LIST = 'dofe-bo/award/GET_AWARDS_OVERVIEW_LIST'
const GET_AWARDS_OVERVIEW_LIST_SUCCESS ='dofe-bo/award/GET_AWARDS_OVERVIEW_LIST_SUCCESS'
const GET_AWARDS_OVERVIEW_LIST_FAIL = 'dofe-bo/award/GET_AWARDS_OVERVIEW_LIST_FAIL'

const GET_AWARDS_OVERVIEW_COUNT = 'dofe-bo/award/GET_AWARDS_OVERVIEW_COUNT'
const GET_AWARDS_OVERVIEW_COUNT_SUCCESS ='dofe-bo/award/GET_AWARDS_OVERVIEW_COUNT_SUCCESS'
const GET_AWARDS_OVERVIEW_COUNT_FAIL = 'dofe-bo/award/GET_AWARDS_OVERVIEW_COUNT_FAIL'

const SET_AWARDS_OVERVIEW_FILTER = 'dofe-bo/award/SET_AWARDS_OVERVIEW_FILTER'
const SET_AWARDS_OVERVIEW_PARAMS = 'dofe-bo/award/SET_AWARDS_OVERVIEW_PARAMS'

const GET_AWARD = 'dofe-bo/award/GET_AWARD'
const GET_AWARD_SUCCESS = 'dofe-bo/award/GET_AWARD_SUCCESS'
const GET_AWARD_FAIL = 'dofe-bo/award/GET_AWARD_FAIL'
const GET_AWARD_FILES = 'dofe-bo/award/GET_AWARD_FILES'
const GET_AWARD_FILES_SUCCESS = 'dofe-bo/award/GET_AWARD_FILES_SUCCESS'
const GET_AWARD_FILES_FAIL = 'dofe-bo/award/GET_AWARD_FILES_FAIL'
const GET_AWARD_FILE = 'dofe-bo/award/GET_AWARD_FILE'
const GET_AWARD_FILE_SUCCESS = 'dofe-bo/award/GET_AWARD_FILE_SUCCESS'
const GET_AWARD_FILE_FAIL = 'dofe-bo/award/GET_AWARD_FILE_FAIL'
const EDIT_AWARD_FILES = 'dofe-bo/award/EDIT_AWARD_FILES'
const EDIT_AWARD_FILES_SUCCESS = 'dofe-bo/award/EDIT_AWARD_FILES_SUCCESS'
const EDIT_AWARD_FILES_FAIL = 'dofe-bo/award/EDIT_AWARD_FILES_FAIL'
const UPLOAD_AWARD_FILES = 'dofe-bo/award/UPLOAD_AWARD_FILES'
const UPLOAD_AWARD_FILES_SUCCESS = 'dofe-bo/award/UPLOAD_AWARD_FILES_SUCCESS'
const UPLOAD_AWARD_FILES_FAIL = 'dofe-bo/award/UPLOAD_AWARD_FILES_FAIL'
const SIGN_OFF_AWARD = 'dofe-bo/awardSignoffTasks/SIGN_OFF_AWARD'
const SIGN_OFF_AWARD_SUCCESS =
    'dofe-bo/awardSignoffTasks/SIGN_OFF_AWARD_SUCCESS'
const SIGN_OFF_AWARD_FAIL = 'dofe-bo/awardSignoffTasks/SIGN_OFF_AWARD_FAIL'
const GET_SIGN_OFF_AWARD_IS_AUTHORIZED =
    'dofe-bo/awardSignoffTasks/GET_SIGN_OFF_AWARD_IS_AUTHORIZED'
const GET_SIGN_OFF_AWARD_IS_AUTHORIZED_SUCCESS =
    'dofe-bo/awardSignoffTasks/GET_SIGN_OFF_AWARD_IS_AUTHORIZED_SUCCESS'
const GET_SIGN_OFF_AWARD_IS_AUTHORIZED_FAIL =
    'dofe-bo/awardSignoffTasks/GET_SIGN_OFF_AWARD_IS_AUTHORIZED_FAIL'
const ASSIGN_LEADER = 'dofe-bo/award/ASSIGN_LEADER'
const ASSIGN_LEADER_SUCCESS = 'dofe-bo/award/ASSIGN_LEADER_SUCCESS'
const ASSIGN_LEADER_FAIL = 'dofe-bo/award/ASSIGN_LEADER_FAIL'
const UPDATE_AWARD_PAYMENTS = 'dofe-bo/award/UPDATE_AWARD_PAYMENTS'
const UPDATE_AWARD_PAYMENTS_SUCCESS =
    'dofe-bo/award/UPDATE_AWARD_PAYMENTS_SUCCESS'
const UPDATE_AWARD_PAYMENTS_FAIL = 'dofe-bo/award/UPDATE_AWARD_PAYMENTS_FAIL'
const UPDATE_AWARD = 'dofe-bo/award/UPDATE_AWARD'
const UPDATE_AWARD_SUCCESS = 'dofe-bo/award/UPDATE_AWARD_SUCCESS'
const UPDATE_AWARD_FAIL = 'dofe-bo/award/UPDATE_AWARD_FAIL'
const APPROVE_AWARD_REGISTRATION = 'dofe-bo/award/APPROVE_AWARD_REGISTRATION'
const APPROVE_AWARD_REGISTRATION_SUCCESS =
    'dofe-bo/award/APPROVE_AWARD_REGISTRATION_SUCCESS'
const APPROVE_AWARD_REGISTRATION_FAIL =
    'dofe-bo/award/APPROVE_AWARD_REGISTRATION_FAIL'
const CHANGE_AWARD_ACTIVITY = 'dofe-bo/award/CHANGE_AWARD_ACTIVITY'
const CHANGE_AWARD_ACTIVITY_SUCCESS =
    'dofe-bo/award/CHANGE_AWARD_ACTIVITY_SUCCESS'
const CHANGE_AWARD_ACTIVITY_FAIL = 'dofe-bo/award/CHANGE_AWARD_ACTIVITY_FAIL'
const GET_AWARD_REPORT = 'dofe-bo/award/GET_AWARD_REPORT'
const GET_AWARD_REPORT_SUCCESS = 'dofe-bo/award/GET_AWARD_REPORT_SUCCESS'
const GET_AWARD_REPORT_FAIL = 'dofe-bo/award/GET_AWARD_REPORT_FAIL'
const GET_AWARD_PREPARATION_TRAININGS =
    'dofe-bo/award/GET_AWARD_PREPARATION_TRAININGS'
const GET_AWARD_PREPARATION_TRAININGS_SUCCESS =
    'dofe-bo/award/GET_AWARD_PREPARATION_TRAININGS_SUCCESS'
const GET_AWARD_PREPARATION_TRAININGS_FAIL =
    'dofe-bo/award/GET_AWARD_PREPARATION_TRAININGS_FAIL'
const APPROVE_AJ_PREP_TRAINING = 'dofe-bo/award/APPROVE_AJ_PREP_TRAINING'
const APPROVE_AJ_PREP_TRAINING_SUCCESS =
    'dofe-bo/award/APPROVE_AJ_PREP_TRAINING_SUCCESS'
const APPROVE_AJ_PREP_TRAINING_FAIL =
    'dofe-bo/award/APPROVE_AJ_PREP_TRAINING_FAIL'

const CHANGE_STATE_AJ_PREP_TRAINING = 'dofe-bo/award/CHANGE_STATE_AJ_PREP_TRAINING'
const CHANGE_STATE_AJ_PREP_TRAINING_SUCCESS = 'dofe-bo/award/CHANGE_STATE_AJ_PREP_TRAINING_SUCCESS'
const CHANGE_STATE_AJ_PREP_TRAINING_FAIL = 'dofe-bo/award/CHANGE_STATE_AJ_PREP_TRAINING_FAIL'

const CREATE_AWARD_PREPARATION_TRAININGS =
    'dofe-bo/award/CREATE_AWARD_PREPARATION_TRAININGS'
const CREATE_AWARD_PREPARATION_TRAININGS_SUCCESS =
    'dofe-bo/award/CREATE_AWARD_PREPARATION_TRAININGS_SUCCESS'
const CREATE_AWARD_PREPARATION_TRAININGS_FAIL =
    'dofe-bo/award/CREATE_AWARD_PREPARATION_TRAININGS_FAIL'
const GET_AL_SIGN_OFFS = 'dofe-bo/award/GET_AL_SIGN_OFFS'
const GET_AL_SIGN_OFFS_SUCCESS = 'dofe-bo/award/GET_AL_SIGN_OFFS_SUCCESS'
const GET_AL_SIGN_OFFS_FAIL = 'dofe-bo/award/GET_AL_SIGN_OFFS_FAIL'
const SET_FILTER = 'dofe-bo/award/SET_FILTER'
const SET_PARAMS = 'dofe-bo/award/SET_PARAMS'
const REMOVE_DATA = 'dofe-bo/award/REMOVE_DATA'
const REMOVE_FILES_DATA = 'dofe-bo/award/REMOVE_FILES_DATA'
const CHANGE_LEADER = 'dofe-bo/award/CHANGE_LEADER'
const CHANGE_LEADER_SUCCESS = 'dofe-bo/award/CHANGE_LEADER_SUCCESS'
const CHANGE_LEADER_FAIL = 'dofe-bo/award/CHANGE_LEADER_FAIL'

const ALLOWED_AWARD_STATES = 'dofe-bo/award/ALLOWED_AWARD_STATES'
const ALLOWED_AWARD_STATES_SUCCESS =
    'dofe-bo/award/ALLOWED_AWARD_STATES_SUCCESS'
const ALLOWED_AWARD_STATES_FAIL = 'dofe-bo/award/ALLOWED_AWARD_STATES_FAIL'

const RESEND_PARENTAL_CONSENT = 'dofe-bo/award/RESEND_PARENTAL_CONSENT'
const RESEND_PARENTAL_CONSENT_SUCCESS =
    'dofe-bo/award/RESEND_PARENTAL_CONSENT_SUCCESS'
const RESEND_PARENTAL_CONSENT_FAIL =
    'dofe-bo/award/RESEND_PARENTAL_CONSENT_FAIL'

const OFFLINE_ALLOWED_AWARD_STATES =
    'dofe-bo/award/OFFLINE_ALLOWED_AWARD_STATES'
const OFFLINE_ALLOWED_AWARD_STATES_SUCCESS =
    'dofe-bo/award/OFFLINE_ALLOWED_AWARD_STATES_SUCCESS'
const OFFLINE_ALLOWED_AWARD_STATES_FAIL =
    'dofe-bo/award/OFFLINE_ALLOWED_AWARD_STATES_FAIL'

const INVITE_PARTICIPANT_TO_NEXT_LEVEL =
    'dofe-bo/award/INVITE_PARTICIPANT_TO_NEXT_LEVEL'
const INVITE_PARTICIPANT_TO_NEXT_LEVEL_SUCCESS =
    'dofe-bo/award/INVITE_PARTICIPANT_TO_NEXT_LEVEL_SUCCESS'
const INVITE_PARTICIPANT_TO_NEXT_LEVEL_FAIL =
    'dofe-bo/award/INVITE_PARTICIPANT_TO_NEXT_LEVEL_FAIL'

const CHANGE_AWARD_TYPE ='dofe-bo/award/CHANGE_AWARD_TYPE'
const CHANGE_AWARD_TYPE_SUCCESS = 'dofe-bo/award/CHANGE_AWARD_TYPE_SUCCESS'
const CHANGE_AWARD_TYPE_FAIL = 'dofe-bo/award/CHANGE_AWARD_TYPE_FAIL'

const initialState = {
    list: [],
    overview: {
      list: [],
      sort: '',
      offset: 0,
      limit: 20,
      pages: 4,
      count: null,
      filter: '',
      loading: false,
      loaded: false,
      countLoading: false,
      countLoaded: false
    },
    files: {
        list: [],
        detail: {}
    },
    report: {
        data: null,
        loading: false
    },
    detail: {},
    preparationTrainings: [],
    allowedLevels: [],
    offlineAllowedLevels: [],
    sort: '',
    offset: 0,
    limit: 20,
    pages: 1,
    count: null,
    filter: '',
    loading: false,
    awardLevelLoading: false,
    loaded: false
}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case GET_AWARDS_LIST:
            return {
                ...state,
                loading: true
            }
        case GET_AWARDS_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                loaded: true,
                list: action.result,
                count: Number(action.headers['x-total-count']),
                pages: Math.ceil(
                    Number(action.headers['x-total-count']) / state.limit
                ) || state.pages
            }
        case GET_AWARDS_LIST_FAIL:
            return {
                ...state,
                loading: false,
                loaded: false,
                error: action.error
            }
      case GET_AWARDS_OVERVIEW_LIST:
        return {
          ...state,
          overview: {
            ...state.overview,
            loading: true
          }
        }
      case GET_AWARDS_OVERVIEW_LIST_SUCCESS:
        return {
          ...state,
          overview: {
            ...state.overview,
            loading: false,
            loaded: true,
            list: action.result.list
          }
        }
      case GET_AWARDS_OVERVIEW_LIST_FAIL:
        return {
          ...state,
          overview: {
            ...state.overview,
            loading: false,
            loaded: false,
            error: action.error
          }
        }
      case GET_AWARDS_OVERVIEW_COUNT:
        return {
          ...state,
          overview: {
            ...state.overview,
            countLoaded: false,
            countLoading: true
          }
        }
      case GET_AWARDS_OVERVIEW_COUNT_SUCCESS:
        const totalCount = Number(get(action.result, 'totalCount') || 0)
        return {
          ...state,
          overview: {
            ...state.overview,
            countLoading: false,
            countLoaded: true,
            count: totalCount,
            pages:
              Math.ceil(totalCount / state.limit) ||
              state.pages
          }
        }
      case GET_AWARDS_OVERVIEW_COUNT_FAIL:
        return {
          ...state,
          overview: {
            ...state.overview,
            loading: false,
            loaded: false,
            error: action.error
          }
        }
      case SET_AWARDS_OVERVIEW_FILTER:
        return {
          ...state,
          overview: {
            ...state.overview,
            filter: action.filterBy,
            offset: 0,
            invalidate: new Date().getTime()
          }
        }
      case SET_AWARDS_OVERVIEW_PARAMS:
        return {
          ...state,
          overview: {
            ...state.overview,
            limit:
              action.options.limit !== undefined
                ? action.options.limit
                : state.overview.limit,
            offset:
              action.options.offset !== undefined
                ? action.options.offset
                : state.overview.offset,
            filter:
              action.options.filter !== undefined
                ? action.options.filter
                : state.overview.filter,
            sort:
              action.options.sort !== undefined ? action.options.sort : state.overview.sort
          }
        }
        case GET_AWARD:
            return {
                ...state,
                loaded: false,
                loading: true
            }
        case GET_AWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                loaded: true,
                detail: action.result
            }
        case GET_AWARD_FAIL:
            return {
                ...state,
                loading: false,
                loaded: false,
                error: action.error
            }
        case GET_AWARD_FILES:
            return {
                ...state,
                loaded: false,
                loadingFiles: true,
                files: {
                    ...state.files,
                    list: []
                }
            }
        case GET_AWARD_FILES_SUCCESS:
            return {
                ...state,
                loadingFiles: false,
                files: {
                    ...state.files,
                    list: action.result
                }
            }
        case GET_AWARD_FILES_FAIL:
            return {
                ...state,
                loadingFiles: false,
                loaded: false,
                error: action.error
            }
        case GET_AWARD_FILE:
            return {
                ...state,
                loaded: false,
                loading: true
            }
        case GET_AWARD_FILE_SUCCESS:
            return {
                ...state,
                loading: false,
                loaded: true,
                files: {
                    ...state.files,
                    detail: action.result[0]
                }
            }
        case GET_AWARD_FILE_FAIL:
            return {
                ...state,
                loading: false,
                loaded: false,
                error: action.error
            }
        case GET_AWARD_PREPARATION_TRAININGS_SUCCESS:
            return {
                ...state,
                loading: false,
                loaded: true,
                preparationTrainings: action.result
            }
        case ALLOWED_AWARD_STATES:
            return {
                ...state,
                loaded: false,
                awardLevelLoading: true
            }
        case ALLOWED_AWARD_STATES_SUCCESS:
            return {
                ...state,
                awardLevelLoading: false,
                loaded: true,
                allowedLevels: action.result
            }
        case ALLOWED_AWARD_STATES_FAIL:
            return {
                ...state,
                awardLevelLoading: false,
                loaded: false,
                error: action.error
            }
        case OFFLINE_ALLOWED_AWARD_STATES:
            return {
                ...state,
                loaded: false,
                awardLevelLoading: true
            }
        case OFFLINE_ALLOWED_AWARD_STATES_SUCCESS:
            return {
                ...state,
                awardLevelLoading: false,
                loaded: true,
                offlineAllowedLevels: action.result
            }
        case OFFLINE_ALLOWED_AWARD_STATES_FAIL:
            return {
                ...state,
                awardLevelLoading: false,
                loaded: false,
                error: action.error
            }
        case CHANGE_LEADER:
        case UPDATE_AWARD:
            return {
                ...state,
                loading: true
            }
        case CHANGE_LEADER_SUCCESS:
        case UPDATE_AWARD_SUCCESS:
            return {
                ...state,
                loading: false
            }
        case CHANGE_LEADER_FAIL:
        case UPDATE_AWARD_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            }
        case UPLOAD_AWARD_FILES:
            return {
                ...state,
                loading: true
            }
        case UPLOAD_AWARD_FILES_SUCCESS:
            return {
                ...state,
                loading: false
            }
        case UPLOAD_AWARD_FILES_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            }
        case UPDATE_AWARD_PAYMENTS:
            return {
                ...state,
                loading: true
            }
        case UPDATE_AWARD_PAYMENTS_SUCCESS:
            return {
                ...state,
                loading: false
            }
        case GET_AWARD_REPORT:
            return {
                ...state,
                report: {
                    ...state.report,
                    loading: true
                }
            }
        case GET_AWARD_REPORT_SUCCESS:
            return {
                ...state,
                report: {
                    ...state.report,
                    loading: false,
                    data: action.result
                }
            }
        case GET_AWARD_REPORT_FAIL:
            return {
                ...state,
                report: {
                    ...state.report,
                    loading: false,
                    error: action.error
                }
            }
        case GET_SIGN_OFF_AWARD_IS_AUTHORIZED:
            return {
                ...state,
                signOffloaded: false,
                loadingSignOffAuthorized: true,
                signOffAuthorized: false
            }
        case GET_SIGN_OFF_AWARD_IS_AUTHORIZED_SUCCESS:
            return {
                ...state,
                loadingSignOffAuthorized: false,
                signOffloaded: true,
                signOffAuthorized: action.result.isAuthorized
            }
        case GET_SIGN_OFF_AWARD_IS_AUTHORIZED_FAIL:
            return {
                ...state,
                loadingSignOffAuthorized: false,
                signOffloaded: false,
                signOffAuthorized: false,
                error: action.error
            }
        case INVITE_PARTICIPANT_TO_NEXT_LEVEL:
            return {
                ...state,
                inviteLoading: true
            }
        case INVITE_PARTICIPANT_TO_NEXT_LEVEL_SUCCESS:
            return {
                ...state,
                inviteLoading: false
            }
        case INVITE_PARTICIPANT_TO_NEXT_LEVEL_FAIL:
            return {
                ...state,
                inviteLoading: false
            }
        case CHANGE_AWARD_TYPE:
          return {
            ...state,
            loading: true
          }
        case CHANGE_AWARD_TYPE_SUCCESS:
          return {
            ...state,
            loading: false,
            loaded: true
          }
        case CHANGE_AWARD_TYPE_FAIL:
          return {
            ...state,
            loading: false,
            loaded: false,
            error: action.error
          }
        case UPDATE_AWARD_PAYMENTS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            }
        case SET_FILTER:
            return Object.assign({}, state, state.awards, {
                filter: action.filterBy
            })
        case SET_PARAMS:
            return {
                ...state,
                limit: action.options.limit !== undefined
                    ? action.options.limit
                    : state.limit,
                offset: action.options.offset !== undefined
                    ? action.options.offset
                    : state.offset,
                filter: action.options.filter !== undefined
                    ? action.options.filter
                    : state.filter,
                sort: action.options.sort !== undefined
                    ? action.options.sort
                    : state.sort
            }
        case REMOVE_FILES_DATA:
            return {
                ...state,
                files: {
                    list: [],
                    detail: {}
                }
            }

        case REMOVE_DATA:
            return initialState
      case SIGN_OFF_AWARD:
        return {
          ...state,
          loading: true
        }
      case SIGN_OFF_AWARD_SUCCESS:
        return {
          ...state,
          loading: false,
          loaded: true
        }
      case SIGN_OFF_AWARD_FAIL:
        return {
          ...state,
          loading: false,
          loaded: false,
          error: action.error
        }
        default:
            return state
    }
}

export function getAwards(
    params = {},
    baseFilter,
    queryParams,
    { withTs } = {}
) {
    const readParams = `APPEND_CUSTOMIZATIONS,ASSESSOR_REGISTRATION_DATA,BADGES_IMAGES,BADGES,ADVENTUROUS_JOURNEYS,ASSESSOR,ACTIVITIES_WITH_PROGRESS,AWARD_LEVEL,PARTICIPANT_PERSON${queryParams ? `,${queryParams}` : ''}`

    const ts = withTs ? `&ts=${moment().unix()}` : ''

    return {
        types: [GET_AWARDS_LIST, GET_AWARDS_LIST_SUCCESS, GET_AWARDS_LIST_FAIL],
        promise: client =>
            client.get(
                `api/awards?with=${readParams}${routeParams(params, baseFilter)}${ts}`
            )
    }
}

export function getAward(id, readParams) {
    const params = `PARTICIPANT_PERSON${readParams ? `,${readParams}` : ''}`

    return {
        types: [GET_AWARD, GET_AWARD_SUCCESS, GET_AWARD_FAIL],
        promise: client => client.get(`api/awards/${id}?with=${params}`)
    }
}

export function getAwardFiles(id) {
    return {
        types: [GET_AWARD_FILES, GET_AWARD_FILES_SUCCESS, GET_AWARD_FILES_FAIL],
        promise: client => client.get(`api/awards/${id}/award-files?with=AUTHOR,AJ_EVENT`)
    }
}

export function getAwardFile(id, fileId) {
    return {
        types: [GET_AWARD_FILE, GET_AWARD_FILE_SUCCESS, GET_AWARD_FILE_FAIL],
        promise: client =>
            client.get(`api/awards/${id}/award-files?with=AUTHOR&filter=id=${fileId}`)
    }
}

export function getAwardLeaderSignOffs(id, requestId) {
    return {
        types: [GET_AL_SIGN_OFFS, GET_AL_SIGN_OFFS_SUCCESS, GET_AL_SIGN_OFFS_FAIL],
        promise: client =>
            client.get(`api/awards/${id}/leader-sign-offs/${requestId}`)
    }
}

export function getAwardReport(id, type) {
    switch(type) {
        case 1:
            return {
                types: [GET_AWARD_REPORT, GET_AWARD_REPORT_SUCCESS, GET_AWARD_REPORT_FAIL],
                promise: client => client.get(`api/awards/${id}/summary-report-generation`)
            }
        case 2:
            return {
                types: [GET_AWARD_REPORT, GET_AWARD_REPORT_SUCCESS, GET_AWARD_REPORT_FAIL],
                promise: client => client.get(`api/awards/${id}/award-detail-report-generation`)
            }
        default :
                return {
                    types: [GET_AWARD_REPORT, GET_AWARD_REPORT_SUCCESS, GET_AWARD_REPORT_FAIL],
                    promise: client => client.get(`api/awards/${id}/summary-report-generation`)
                }
    }
}

export function uploadAwardFiles(id, data) {
    return {
        types: [
            UPLOAD_AWARD_FILES,
            UPLOAD_AWARD_FILES_SUCCESS,
            UPLOAD_AWARD_FILES_FAIL
        ],
        promise: client =>
            client.post(`api/awards/${id}/award-files`, {
                data
            })
    }
}

export function deleteAwardFile(id, fileId) {
    return {
        types: [
            UPLOAD_AWARD_FILES,
            UPLOAD_AWARD_FILES_SUCCESS,
            UPLOAD_AWARD_FILES_FAIL
        ],
        promise: client => client.del(`api/awards/${id}/award-files/${fileId}`)
    }
}

export function editAwardFile(id, fileId, data) {
    return {
        types: [EDIT_AWARD_FILES, EDIT_AWARD_FILES_SUCCESS, EDIT_AWARD_FILES_FAIL],
        promise: client =>
            client.put(`api/awards/${id}/award-files/${fileId}?update=OTHER`, {
                data
            })
    }
}

export function getAwardPreparationTrainings(id) {
    return {
        types: [
            GET_AWARD_PREPARATION_TRAININGS,
            GET_AWARD_PREPARATION_TRAININGS_SUCCESS,
            GET_AWARD_PREPARATION_TRAININGS_FAIL
        ],
        promise: client => client.get(`api/awards/${id}/aj-preparation-trainings`)
    }
}

export function crudAwardPreparationTraining(id, data) {
    return {
        types: [
            CREATE_AWARD_PREPARATION_TRAININGS,
            CREATE_AWARD_PREPARATION_TRAININGS_SUCCESS,
            CREATE_AWARD_PREPARATION_TRAININGS_FAIL
        ],
        promise: client =>
            client.post(`api/awards/${id}/aj-preparation-trainings`, {
                data
            })
    }
}

export function assignLeader(id, data) {
    return {
        types: [ASSIGN_LEADER, ASSIGN_LEADER_SUCCESS, ASSIGN_LEADER_FAIL],
        promise: client =>
            client.post(`api/awards/${id}/assignment-leader`, {
                data
            })
    }
}

export function signoffAward(id, data) {
    return {
        types: [SIGN_OFF_AWARD, SIGN_OFF_AWARD_SUCCESS, SIGN_OFF_AWARD_FAIL],
        promise: client =>
            client.post(`api/awards/${id}/award-leader-signoff`, {
                data
            })
    }
}

export function signoffAwardOffice(id, data) {
    return {
        types: [SIGN_OFF_AWARD, SIGN_OFF_AWARD_SUCCESS, SIGN_OFF_AWARD_FAIL],
        promise: client =>
            client.post(`api/awards/${id}/award-office-signoff`, {
                data
            })
    }
}

export function getSignoffAwardOfficeIsAuthorized(id) {
    return {
        types: [GET_SIGN_OFF_AWARD_IS_AUTHORIZED,
            GET_SIGN_OFF_AWARD_IS_AUTHORIZED_SUCCESS,
            GET_SIGN_OFF_AWARD_IS_AUTHORIZED_FAIL],
        promise: client =>
            client.get(`api/awards/${id}/award-office-signoff/authorization-result`)
    }
}

export function updateAwardPaymentInfo(id, data) {
    return {
        types: [
            UPDATE_AWARD_PAYMENTS,
            UPDATE_AWARD_PAYMENTS_SUCCESS,
            UPDATE_AWARD_PAYMENTS_FAIL
        ],
        promise: client =>
            client.put(`api/awards/${id}/payments`, {
                data
            })
    }
}

export function updateAward(id, data, updateDefinition) {
    return {
        types: [UPDATE_AWARD, UPDATE_AWARD_SUCCESS, UPDATE_AWARD_FAIL],
        promise: client =>
            client.put(
                `api/awards/${id}${updateDefinition ? `?update=${updateDefinition}` : ''}`,
                {
                    data
                }
            )
    }
}

export function changeLeader(awardId, leaderId) {
    return {
        types: [CHANGE_LEADER, CHANGE_LEADER_SUCCESS, CHANGE_LEADER_FAIL],
        promise: client =>
            client.post(
                `api/awards/${awardId}/change-leader?awardLeaderId=${leaderId}`
            )
    }
}

export function approveAwardRegistration(id, data) {
    return {
        types: [
            APPROVE_AWARD_REGISTRATION,
            APPROVE_AWARD_REGISTRATION_SUCCESS,
            APPROVE_AWARD_REGISTRATION_FAIL
        ],
        promise: client =>
            client.post(`api/awards/${id}/registration-approval`, {
                data
            })
    }
}

export function approveAjPreparationTraining(id, data) {
    return {
        types: [
            APPROVE_AJ_PREP_TRAINING,
            APPROVE_AJ_PREP_TRAINING_SUCCESS,
            APPROVE_AJ_PREP_TRAINING_FAIL
        ],
        promise: client =>
            client.post(
                `api/awards/${id}/aj-preparation-trainings/award-leader-signoff`,
                {
                    data
                }
            )
    }
}

export function changeAjPrepAndTrainState(id, state) {
    return {
        types: [
            CHANGE_STATE_AJ_PREP_TRAINING,
            CHANGE_STATE_AJ_PREP_TRAINING_SUCCESS,
            CHANGE_STATE_AJ_PREP_TRAINING_FAIL
        ],
        promise: client =>
            client.post(`api/awards/${id}/aj-preparation-trainings/state-change?state=${state}`)
    }
}

export function changeAwardState(id, state, data = {}) {
    return {
        types: [
            CHANGE_AWARD_ACTIVITY,
            CHANGE_AWARD_ACTIVITY_SUCCESS,
            CHANGE_AWARD_ACTIVITY_FAIL
        ],
        promise: client =>
            client.post(`api/awards/${id}/state-change?state=${state}`, {
                data
            })
    }
}

export function allowedAwardLevels(id) {
    return {
        types: [
            ALLOWED_AWARD_STATES,
            ALLOWED_AWARD_STATES_SUCCESS,
            ALLOWED_AWARD_STATES_FAIL
        ],
        promise: client => client.get(`api/awards/${id}/allowed-award-levels`)
    }
}

export function allowedOfflineAwardLevels(id) {
    return {
        types: [
            OFFLINE_ALLOWED_AWARD_STATES,
            OFFLINE_ALLOWED_AWARD_STATES_SUCCESS,
            OFFLINE_ALLOWED_AWARD_STATES_FAIL
        ],
        promise: client =>
            client.get(`api/awards/${id}/allowed-offline-award-levels`)
    }
}

export function resendParentalConsentLink(id) {
    return {
        types: [
            RESEND_PARENTAL_CONSENT,
            RESEND_PARENTAL_CONSENT_SUCCESS,
            RESEND_PARENTAL_CONSENT_FAIL
        ],
        promise: client =>
            client.post(`api/awards/${id}/resend-parental-consent-link`)
    }
}

export function inviteParticipantToNextLevel(id) {
    return {
        types: [
            INVITE_PARTICIPANT_TO_NEXT_LEVEL,
            INVITE_PARTICIPANT_TO_NEXT_LEVEL_SUCCESS,
            INVITE_PARTICIPANT_TO_NEXT_LEVEL_FAIL
        ],
        promise: client =>
            client.post(`api/awards/${id}/next-level-registration-invitation`)
    }
}

export function setAwardsFilter(filterBy) {
    return {
        type: SET_FILTER,
        filterBy
    }
}

export function setAwardsParams(options) {
    return {
        type: SET_PARAMS,
        options
    }
}

export function removeAwardFilesData() {
    return {
        type: REMOVE_FILES_DATA
    }
}

export function removeAwardData() {
    return {
        type: REMOVE_DATA
    }
}

export function setAwardsOverviewFilter(filterBy) {
  return {
    type: SET_AWARDS_OVERVIEW_FILTER,
    filterBy
  }
}

export function setAwardsOverviewParams(options) {
  return {
    type: SET_AWARDS_OVERVIEW_PARAMS,
    options
  }
}

export function changeAwardType(id) {
  return {
    types: [
      CHANGE_AWARD_TYPE,
      CHANGE_AWARD_TYPE_SUCCESS,
      CHANGE_AWARD_TYPE_FAIL
    ],
    promise: client =>
      client.post(`api/awards/${id}/change-type`)
  }
}

export function getAwardsOverview(params = {}, baseFilter) {
  return {
    types: [
      GET_AWARDS_OVERVIEW_LIST,
      GET_AWARDS_OVERVIEW_LIST_SUCCESS,
      GET_AWARDS_OVERVIEW_LIST_FAIL
    ],
    promise: client =>
      client.post(
        `apiv2/award/overview/list`, {
          data: {
            sort: getApiSort(params.sort),
            filter: buildAwardOverviewFilter(params),
            paging: getApiPaging(params.offset, params.limit),
            options: {
              getRecordList: true,
              getTotalCount: false
            }
          }
        }
      )
  }
}


export function getAwardsOverviewCount(params = {}, baseFilter) {
  return {
    types: [
      GET_AWARDS_OVERVIEW_COUNT,
      GET_AWARDS_OVERVIEW_COUNT_SUCCESS,
      GET_AWARDS_OVERVIEW_COUNT_FAIL
    ],
    promise: client =>
      client.post(
        `apiv2/award/overview/list`, {
          data: {
            sort: getApiSort(params.sort),
            filter: buildAwardOverviewFilter(params),
            paging: getApiPaging(params.offset, params.limit),
            options: {
              getRecordList: false,
              getTotalCount: true
            }
          }
        }
      )
  }
}


function buildAwardOverviewFilter(params) {
  const filterBuilder = getApiFilterBuilder(params.filter)
    .parse('personState@eq', 'participant.state')
    .parse('awardLevel@in', 'level', i => i.value)
    .parse('awardOrganization@in', 'organizationId', i => i.value)
    .parse('registrationDate@gte', 'registrationDate')
    .parse('registrationDate@lt', 'registrationDate')

  return filterBuilder.build()
}


